import React from 'react';
import PropTypes from 'prop-types';

import { Link, Typography } from '@klarna/bubble-ui';

const TermsAndConditionsLink = ({
  textBeforeLink,
  linkText,
  textAfterLink,
  tocLink,
  light: isLight,
}) => {
  const colorToken = isLight ? 'colors/text/neutral' : 'colors/text/default';
  return (
    <Typography textToken="text-style/text/super-paragraphs/tall/regular" colorToken={colorToken}>
      {textBeforeLink}
      &nbsp;
      <Link isUnderlined href={tocLink} target="_blank">
        {linkText}
      </Link>
      &nbsp;
      {textAfterLink}
    </Typography>
  );
};

TermsAndConditionsLink.propTypes = {
  linkText: PropTypes.object.isRequired,
  textAfterLink: PropTypes.object.isRequired,
  textBeforeLink: PropTypes.object.isRequired,
  light: PropTypes.bool,
  tocLink: PropTypes.string,
};

export default TermsAndConditionsLink;
